import { For, Show } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ImageItemType } from '~/types/ImageViewer'

export interface GalleryPropsType {
  images: ImageItemType[]
  class?: string
  onClick?: (index: number) => void
}

const Gallery = (props: GalleryPropsType) => {
  return (
    <div class={twMerge('grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4', props.class)}>
      <For each={props.images}>
        {(img, i) => (
          <button
            type="button"
            class="group overflow-hidden rounded-xl border border-border bg-surface-muted transition hover:ring-2 hover:ring-primary-500 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:outline-none"
            onClick={() => props.onClick?.(i())}
          >
            <div class="relative aspect-[4/3]">
              <img
                src={img.src}
                alt={img.alt ?? img.caption ?? `Imagen ${i() + 1}`}
                class="absolute inset-0 h-full w-full object-cover transition duration-300 group-hover:scale-105"
                loading="lazy"
                draggable={false}
              />
              <Show when={img.caption}>
                <span class="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/40 to-transparent px-2.5 pt-8 pb-1.5 text-left text-xs font-medium text-white truncate">
                  {img.caption}
                </span>
              </Show>
            </div>
          </button>
        )}
      </For>
    </div>
  )
}

export default Gallery
